(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ConservationPracticesController = (function(superClass) {
    extend(ConservationPracticesController, superClass);

    function ConservationPracticesController(scope, transitions, modal, http, service) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.practiceIsSelected = bind(this.practiceIsSelected, this);
      this.togglePractice = bind(this.togglePractice, this);
      this.toggleConservationPractice = bind(this.toggleConservationPractice, this);
      this.descriptionPurposeDialog = bind(this.descriptionPurposeDialog, this);
      ConservationPracticesController.__super__.constructor.apply(this, arguments);
      if (this.service.fpcResult.irrigation_map && this.service.fpcResult.irrigation_map.details.tail_water_recovery) {
        if (!this.practiceIsSelected('Irrigation System, Tail Water Recovery', 'conservation_practices')) {
          this.service.fpcResult.data['conservation_practices'].push('Irrigation System, Tail Water Recovery');
        }
      }
    }

    ConservationPracticesController.prototype.descriptionPurposeDialog = function() {
      return this.modal.open({
        windowClass: 'large_dialog',
        templateUrl: 'backend/grower/fieldprint/description-purpose-dialog',
        controller: 'DialogController'
      });
    };

    ConservationPracticesController.prototype.toggleConservationPractice = function(practice) {
      if (this.practiceIsSelected(practice, 'conservation_practices')) {
        _.remove(this.service.fpcResult.data.conservation_practices, (function(_this) {
          return function(item) {
            return item === practice;
          };
        })(this));
        return;
      }
      return this.service.fpcResult.data.conservation_practices.push(practice);
    };

    ConservationPracticesController.prototype.togglePractice = function(practice, key) {
      if (this.practiceIsSelected(practice, key)) {
        _.remove(this.service.fpcResult.data[key], (function(_this) {
          return function(item) {
            return item === practice;
          };
        })(this));
        return;
      }
      return this.service.fpcResult.data[key].push(practice);
    };

    ConservationPracticesController.prototype.practiceIsSelected = function(practice, key) {
      return _.find(this.service.fpcResult.data[key], (function(_this) {
        return function(item) {
          return item === practice;
        };
      })(this));
    };

    return ConservationPracticesController;

  })(Controller);

}).call(this);
